import { render, staticRenderFns } from "./snForm.vue?vue&type=template&id=38eb3774&scoped=true&"
import script from "./snForm.vue?vue&type=script&lang=js&"
export * from "./snForm.vue?vue&type=script&lang=js&"
import style0 from "./snForm.vue?vue&type=style&index=0&id=38eb3774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb3774",
  null
  
)

export default component.exports